/* eslint-disable no-console */
import React, { useState } from "react";
import { Image, Button, Icon, Confirm, Label } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { buildStorageUrl, formatEventDate } from "../../../../utils";
import { Event } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { EventForm } from "../EventForm";
import "./EventItem.scss";

const eventController = new Event();

export function EventItem(props) {
  const { event, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const { accessToken } = useAuth();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateEvent = () => {
    setTitleModal(`Actualizar: ${event.title}`);
    onOpenCloseModal();
  };

  const onDelete = async () => {
    try {
      await eventController.deleteEvent(accessToken, event.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      draft: "grey",
      published: "green",
      cancelled: "red",
      completed: "blue",
    };
    return colors[status] || "grey";
  };

  const getStatusText = (status) => {
    const texts = {
      draft: "Borrador",
      published: "Publicado",
      cancelled: "Cancelado",
      completed: "Completado",
    };
    return texts[status] || status;
  };

  const getAudienceText = (audience) => {
    const texts = {
      all: "Todos",
      students: "Estudiantes",
      teachers: "Docentes",
      parents: "Padres",
      public: "Público",
    };
    return texts[audience] || audience;
  };

  const formatDate = (date) => {
    try {
      return formatEventDate(date, "dd MMM yyyy, hh:mm a");
    } catch {
      return "Fecha no disponible";
    }
  };

  const getImageUrl = () => {
    if (event.imageUrl) {
      return event.imageUrl.startsWith("http")
        ? event.imageUrl
        : buildStorageUrl(event.imageUrl);
    }
    return null;
  };

  return (
    <>
      <div className="event-item">
        <div className="event-item__image-wrapper">
          {getImageUrl() ? (
            <Image src={getImageUrl()} className="event-item__image" />
          ) : (
            <div className="event-item__image-placeholder">
              <Icon name="calendar alternate outline" size="massive" />
            </div>
          )}
          <div className="event-item__image-overlay">
            {event.featured && (
              <div className="event-item__featured-badge">
                <Icon name="star" />
              </div>
            )}
            {event.isVirtual && (
              <div className="event-item__virtual-badge">
                <Icon name="video" /> Virtual
              </div>
            )}
          </div>
        </div>

        <div className="event-item__content">
          <div className="event-item__header">
            <Label
              color={getStatusColor(event.status)}
              size="tiny"
              className="event-item__status"
            >
              {getStatusText(event.status)}
            </Label>
            {event.category && (
              <span className="event-item__category">
                <Icon name="tag" />
                {event.category.name}
              </span>
            )}
          </div>

          <h3 className="event-item__title">{event.title}</h3>

          <p className="event-item__description">{event.description}</p>

          <div className="event-item__meta">
            <div className="event-item__meta-item">
              <Icon name="calendar outline" />
              <span>{formatDate(event.eventDate)}</span>
            </div>
            {event.location && !event.isVirtual && (
              <div className="event-item__meta-item">
                <Icon name="map marker alternate" />
                <span>{event.location}</span>
              </div>
            )}
            <div className="event-item__meta-item">
              <Icon name="users" />
              <span>{getAudienceText(event.targetAudience)}</span>
            </div>
          </div>
        </div>

        <div className="event-item__actions">
          {event.slug && (
            <Button
              icon
              info
              compact
              as="a"
              href={`/events/${event.slug}`}
              target="_blank"
              title="Ver evento"
            >
              <Icon name="eye" />
            </Button>
          )}
          <Button icon primary compact onClick={openUpdateEvent} title="Editar">
            <Icon name="pencil" />
          </Button>
          <Button
            icon
            color="red"
            compact
            onClick={onOpenCloseConfirm}
            title="Eliminar"
          >
            <Icon name="trash" />
          </Button>
        </div>
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={titleModal}
        size="large"
        scrolling
      >
        <EventForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          event={event}
        />
      </BasicModal>

      <Confirm
        confirmButton="Eliminar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Está seguro de eliminar el evento "${event.title}"?`}
        size="mini"
      />
    </>
  );
}
